import store from '../store';
export default function useDeviseDiy(param) {
  var _this = this;
  //中间页点击隐藏模块；
  var bindHide = function bindHide(item, key) {
    _this.$nextTick(function () {
      _this.$set(_this.mConfig[key], 'isShow', !_this.mConfig[key].isShow);
    });

    //this.mConfig[key].isShow = !this.mConfig[key].isShow
    store.commit('mobildConfig/UPDATESHOW', item);
  };
  //移动事件
  var onMove = function onMove(e) {
    if (e.relatedContext.element.name == 'search_box') return false;
    if (e.relatedContext.element.name == 'nav_bar') return false;
    return true;
  };

  // 对象转数组
  var objToArr = function objToArr(data) {
    var obj = Object.keys(data).sort();
    var m = obj.map(function (key) {
      return data[key];
    });
    return m;
  };
  return {
    bindHide: bindHide,
    onMove: onMove,
    objToArr: objToArr
  };
}